import { PayrError } from '../types.js';
import { PayrErrorCode } from './errors.js';

const UNSUPPORTED_MESSAGE = 'PAYR SDK requires Chrome 80+, Safari 13+, Firefox 75+, or Edge 80+';
const BROWSER_REQUIRED_MESSAGE = 'Browser environment required';

/**
 * Check if the current environment is unsupported
 */
function isUnsupported(): boolean {
  // IE11: document.documentMode exists
  if (
    'documentMode' in document &&
    (document as Document & { documentMode?: number }).documentMode
  ) {
    return true;
  }

  // IE11 userAgent fallback
  const ua = navigator.userAgent;
  if (ua.indexOf('MSIE') !== -1 || ua.indexOf('Trident/') !== -1) {
    return true;
  }

  // Check required APIs
  if (typeof fetch !== 'function') return true;
  if (typeof Promise === 'undefined') return true;
  if (typeof Map === 'undefined') return true;
  if (typeof Set === 'undefined') return true;

  return false;
}

/**
 * Assert that the browser is supported. Throws PayrError if not.
 */
export function assertBrowserSupported(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    throw new PayrError(BROWSER_REQUIRED_MESSAGE, PayrErrorCode.BROWSER_NOT_SUPPORTED);
  }
  if (isUnsupported()) {
    throw new PayrError(UNSUPPORTED_MESSAGE, PayrErrorCode.BROWSER_NOT_SUPPORTED);
  }
}
